import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty, isLoaded, useFirestoreConnect } from 'react-redux-firebase';
import { flattenDeep, } from 'lodash';
import { familyCollection } from '../constant/firestore';

const selector = 'useFamily';


export default function useFamily() {
  const [loading, setLoading] = useState(false);

  const getData = useSelector(state => state.firestore.ordered[selector]);

  const list = useMemo(() => {
    return (flattenDeep((isEmpty(getData) ? [] : getData)?.map(one => one?.records || [])));
  }, [getData]);

  useFirestoreConnect(() => [
    {
      collection: familyCollection.path,
      storeAs: selector
    }
  ]);

  useEffect(() => setLoading(!isLoaded(getData)), [getData]);

  return { list, loading };
};
